import { getPrivateApi } from "../lib/axiosConfig";
import { RemoveCamQueue } from "../types/camQueue.types";
import { GetStationsResponse, Station } from "../types/stations.types";
import { AppError } from "./classes";
import { getStationCode, getStationId, persistStationId } from "../utils/authMethods";

const api = getPrivateApi();
const endpoint = "/stations";
// O GET /stations é paginado (size padrão 10 no backend); pedimos uma página
// grande o suficiente para trazer todos os postos nas listagens/selects.
const ALL_STATIONS_PAGE_SIZE = 1000;

export const getStations = async (): Promise<Station[]> => {

  try {
    const { data: response } = await api.get<GetStationsResponse>(`${endpoint}`, {
      params: { page: 0, size: ALL_STATIONS_PAGE_SIZE },
    });

    return response.content;

  } catch (error: any) {
    const errMsg = "Erro ao buscar postos!";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
}

export const getStationByCode = async (code: string): Promise<Station> => {

  try {
    const { data: response } = await api.get<Station>(`${endpoint}/code/${code}`);

    return response;

  } catch (error: any) {
    const errMsg = "Erro ao buscar posto!";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
}

// Retorna o id do posto do usuário logado. Usa o valor salvo no localStorage e,
// se não houver (ex.: sessão iniciada antes do id ser persistido no login),
// resolve a partir do código do posto e persiste para os próximos acessos.
export const resolveUserStationId = async (): Promise<string | null> => {
  const storedId = getStationId();
  if (storedId) return storedId;

  const code = getStationCode();
  if (!code) return null;

  const { id } = await getStationByCode(code);
  persistStationId(id);

  return id;
}

export const getQueue = async (station: string, token?: string) => {
    try {
        const response = await api.get(`${endpoint}/queue?station=${station}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error: any) {
        console.error("Erro ao buscar fila: ", error);
        throw error;
    }
}

export const removeFromCamQueue = async (payload: RemoveCamQueue): Promise<void> => {

  try {
    await api.put(`${endpoint}/cam-queue/remove`,
        payload
    );
  } catch (error: any) {
    const errMsg = "Erro ao modificar status!";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
}

export const removeVehicleQueue = async (payload: any): Promise<void> => {

  try {
    await api.put(`${endpoint}/manual-queue/remove`,
        payload
    );
  } catch (error: any) {
    const errMsg = "Erro ao modificar status!";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
}

